import { IsNotEmpty, IsUUID } from 'class-validator';

export class GetDocumentDto {
  @IsNotEmpty()
  @IsUUID()
  documentId: string;

  @IsNotEmpty()
  @IsUUID()
  eventId: string;
}
